
            const data = {"name":"glyph/24/chevron-left","data":{"width":"24","height":"24","viewBox":"0 0 18 18","data":"<path pid=\"0\" d=\"M11.5 16a.744.744 0 0 1-.53-.22L4.72 9.53a.75.75 0 0 1 0-1.061l6.25-6.249a.75.75 0 1 1 1.061 1.061l-5.72 5.72 5.72 5.72a.75.75 0 0 1-.53 1.281Z\" _fill=\"#212121\" class=\"nc-icon-wrapper\"/>","originalColors":[{"type":"fill","color":"#212121"}],"stopColors":[]}}
        
                    module.exports = data
                    